var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"layout"}},[_c('ekk-header'),_c('ekk-menu'),_c('div',{staticClass:"layout-pages"},[_c('ekk-breadcrumb',{attrs:{"breadcrumbList":_vm.$route.matched}}),_c('div',{staticClass:"layout-content"},[_c('router-view')],1)],1),_c('ekk-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }